class ZeroByteFileError extends Error {
  constructor(message: string) {
    super(message)
  }
}

export default ZeroByteFileError
